<div class="device-form">
  <div class="xr-dialog-header">
    <h2 class="device-form-title">{{ title | translate }}</h2>
    <button type="button" class="xr-btn xr-btn--soft xr-btn--icon" (click)="cancel()" [attr.aria-label]="'devices.cancel' | translate">
      <span aria-hidden="true" class="device-form-close">×</span>
    </button>
  </div>

  <form [formGroup]="form" class="device-form-fields" (ngSubmit)="save()">
    @if (mode === 'request') {
      <p class="device-form-hint">{{ 'devices.request_hint' | translate }}</p>
    }

    <label class="device-field">
      <span>{{ 'devices.name' | translate }} *</span>
      <input type="text" formControlName="name" [class.invalid]="form.controls.name.touched && form.controls.name.invalid" />
      @if (form.controls.name.touched && form.controls.name.invalid) {
        <small class="device-field-error">{{ 'devices.required' | translate }}</small>
      }
    </label>

    <label class="device-field">
      <span>{{ 'devices.serial_number' | translate }} *</span>
      <input type="text" formControlName="serial_number" class="device-field-mono"
             [class.invalid]="form.controls.serial_number.touched && form.controls.serial_number.invalid" />
      @if (form.controls.serial_number.touched && form.controls.serial_number.invalid) {
        <small class="device-field-error">{{ 'devices.required' | translate }}</small>
      } @else {
        <small>{{ 'devices.serial_hint' | translate }}</small>
      }
    </label>

    <div class="device-form-grid">
      <label class="device-field">
        <span>{{ 'devices.usage' | translate }} *</span>
        <select formControlName="usage" id="device-usage"
                [class.invalid]="form.controls.usage.touched && form.controls.usage.invalid">
          <option value="">{{ 'devices.not_set' | translate }}</option>
          @for (usage of usages; track usage) {
            <option [value]="usage">{{ 'devices.usage_' + usage | translate }}</option>
          }
        </select>
        @if (form.controls.usage.touched && form.controls.usage.invalid) {
          <small class="device-field-error">{{ 'devices.required' | translate }}</small>
        }
      </label>
      <label class="device-field">
        <span>{{ 'devices.type' | translate }} *</span>
        <select formControlName="device_type" id="device-type"
                [class.invalid]="form.controls.device_type.touched && form.controls.device_type.invalid">
          <option value="">{{ 'devices.not_set' | translate }}</option>
          @for (type of types; track type) {
            <option [value]="type">{{ 'devices.type_' + type | translate }}</option>
          }
        </select>
        @if (typeLocked) {
          <small>{{ 'devices.other_is_phone' | translate }}</small>
        } @else if (form.controls.device_type.touched && form.controls.device_type.invalid) {
          <small class="device-field-error">{{ 'devices.required' | translate }}</small>
        }
      </label>
    </div>

    @if (superadmin) {
      <label class="device-field">
        <span>{{ 'devices.company' | translate }}</span>
        <select formControlName="company" id="device-company">
          @for (company of companies; track company.id) {
            <option [ngValue]="company.id">{{ company.name }}</option>
          }
        </select>
      </label>
    }

    <label class="device-field">
      <span>{{ 'devices.requested_for' | translate }}</span>
      <select formControlName="requested_for" id="device-technician">
        <option [ngValue]="null">{{ 'devices.no_technician' | translate }}</option>
        @for (technician of technicianOptions; track technician.id) {
          <option [ngValue]="technician.id">{{ technician.name }} {{ technician.lastname }}</option>
        }
      </select>
    </label>

    <div class="device-form-grid">
      <label class="device-field">
        <span>{{ 'devices.brand' | translate }}</span>
        <input type="text" formControlName="brand" />
      </label>
      <label class="device-field">
        <span>{{ 'devices.model' | translate }}</span>
        <input type="text" formControlName="model" />
      </label>
    </div>

    <label class="device-field">
      <span>{{ (mode === 'request' ? 'devices.notes' : 'devices.description') | translate }}</span>
      <textarea formControlName="description" rows="3"></textarea>
    </label>

    @if (errorMessage) {
      <p class="device-form-error" role="alert">{{ errorMessage }}</p>
    }

    <div class="xr-dialog-actions device-form-actions">
      <button type="button" class="xr-btn xr-btn--secondary" (click)="cancel()">{{ 'devices.cancel' | translate }}</button>
      <button type="submit" class="xr-btn xr-btn--primary" [disabled]="saving">
        {{ (mode === 'request' ? 'devices.send_request' : 'devices.save') | translate }}
      </button>
    </div>
  </form>
</div>
